import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import Header from './Header'

function Card({ children }: React.PropsWithChildren<Record<string, unknown>>) {
  return (
    <Box
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      padding="s24"
      width="full"
      style={{ flex: '1' }}
    >
      {children}
    </Box>
  )
}

Card.Header = Header

export default Card
